import { parseISO } from 'date-fns';

export function recentItems(items) {
    return [...items].sort((a, b) => {
        return new Date(parseISO(b.postDate.date)) - new Date(parseISO(a.postDate.date));
    });
}

export function agendaItems(items) {
    const futureItems = items.filter((item) => {
        if (item.untilDate) {
            const untilDate = new Date(parseISO(item.untilDate));
            // Add 1 day, as events taking place today should be included.
            untilDate.setDate(untilDate.getDate() + 1);
            return untilDate >= new Date();
        }

        const fromDate = new Date(parseISO(item.fromDate));
        // Add 1 day, as events taking place today should be included.
        fromDate.setDate(fromDate.getDate() + 1);
        return fromDate >= new Date();
    });

    return futureItems.sort((a, b) => {
        return new Date(parseISO(a.fromDate)) - new Date(parseISO(b.fromDate));
    });
}

export function sortAgendaItemsByStartDate(items) {
    return [...items].sort((a, b) => {
        return new Date(parseISO(a.fromDate)) - new Date(parseISO(b.fromDate));
    });
}

export function grantItems(items) {
    if (!items) {
        return [];
    }

    return items
        .sort((a, b) => {
            // Sort by structureOrder, treating undefined/null as a higher value to push them to the end
            const orderA = a.structureOrder === undefined || a.structureOrder === null ? Infinity : a.structureOrder;
            const orderB = b.structureOrder === undefined || b.structureOrder === null ? Infinity : b.structureOrder;
            return orderA - orderB;
        });
}
